export default "__VITE_ASSET__76b9f098__"